(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["wall-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wall-preview')) {
    class WallPreview extends HTMLElement {
      connectedCallback() {
        const data = JSON.parse(this.querySelector('#WallPreviewData')?.textContent || '{}');
        this.walls = data.walls || [];
        this.best = (data.best || {})[this.dataset.handle] || [];
        if (!this.best.length || !this.dataset.finish) return; // no cut-outs for this product
        this.ref = (n) => this.querySelector(`[data-ref="${n}"]`);
        this.finish = this.slug(this.dataset.finish);
        this.wall = this.dataset.startBest === 'true' ? this.best[0] : 'linen';
        const swatches = this.ref('swatches');
        swatches.innerHTML = this.walls
          .map(([id, name, hex]) =>
            `<button type="button" class="wall-preview__swatch" data-wall="${id}" style="--swatch:${hex}" aria-label="${name} wall" title="${name}">` +
            (this.best.includes(id) ? '<span class="wall-preview__dot" aria-hidden="true"></span>' : '') +
            '</button>'
          )
          .join('');
        swatches.addEventListener('click', (e) => {
          const b = e.target.closest('button[data-wall]');
          if (b) { this.wall = b.dataset.wall; this.render(); }
        });
        const hint = this.ref('hint');
        const names = this.best.map((id) => this.name(id).toLowerCase());
        if (hint) hint.textContent = 'Looks especially good on ' + (names.length > 1 ? names.slice(0, -1).join(', ') + ' and ' + names.at(-1) : names[0]) + ' walls.';
        // Follow the Frame option of the product form (radio buttons or dropdown).
        this.onChange = (e) => {
          const t = e.target;
          if (!(t instanceof HTMLElement)) return;
          const opt = t.dataset.optionName || t.selectedOptions?.[0]?.dataset.optionName;
          if (opt !== 'Frame') return;
          this.finish = this.slug(t.value);
          this.render();
        };
        document.addEventListener('change', this.onChange);
        this.hidden = false;
        this.render();
      }
      disconnectedCallback() {
        if (this.onChange) document.removeEventListener('change', this.onChange);
      }
      // Frame option value -> cut-out finish slug; every unframed wording maps to the one rolled-print cut-out.
      slug(value) {
        const s = String(value).toLowerCase().trim();
        return /rolled|unframed/.test(s) ? 'rolled-print' : s.replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      }
      name(id) {
        return (this.walls.find((w) => w[0] === id) || [id, id])[1];
      }
      render() {
        const wall = this.walls.find((w) => w[0] === this.wall) || this.walls[0];
        const img = this.ref('img');
        const finishName = this.finish.replace(/-/g, ' ');
        img.src = `${this.dataset.base}${this.dataset.handle}-${this.finish}.webp`;
        img.alt = this.finish === 'rolled-print'
          ? `${this.dataset.title}, unframed print on a ${wall[1].toLowerCase()} wall`
          : `${this.dataset.title} in a ${finishName} frame on a ${wall[1].toLowerCase()} wall`;
        this.ref('viewer').style.setProperty('--wall', wall[2]);
        this.ref('name').textContent = '· ' + wall[1];
        this.querySelectorAll('button[data-wall]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.wall === this.wall)));
      }
    }
    customElements.define('wall-preview', WallPreview);
  }
  } catch(e) { console.error(e); }
})();

})();
